import * as Yup from 'yup';
import { StepLocationForm } from './step-location-types';
import { wgs84CoordinatesSchema } from '../../../components/form/address-field/address-field-schema';

export const stepLocationSchema = () =>
  Yup.object<StepLocationForm>().shape({
    wgs84Coordinates: wgs84CoordinatesSchema(),
  });
